import { CdkMenuTrigger } from '@angular/cdk/menu';
import { Injectable, OnDestroy, ɵgetDirectives } from '@angular/core';

const triggerMap = new Map<CdkMenuTrigger, CdkMenuTrigger['close']>();

@Injectable({
  providedIn: 'root',
})
export class MenuTriggerMonitorService implements OnDestroy {
  private observer: MutationObserver | null = null;

  startMonitoring() {
    this.observer = new MutationObserver((mutations) => {
      mutations
        .map(({ target }) => target as Element)
        .filter((element) => element.classList.contains('cdk-menu-trigger'))
        .forEach((element) => this.overrideCloseFunction(element));
    });

    // Start observing the document body
    this.observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });
  }

  stopMonitoring() {
    this.restoreOriginalCloseFunctions();
    this.observer?.disconnect();
  }

  ngOnDestroy() {
    this.stopMonitoring();
  }

  private overrideCloseFunction(element: Element) {
    const triggers = ɵgetDirectives(element)
      .filter((element) => element instanceof CdkMenuTrigger)
      .filter((trigger) => !triggerMap.has(trigger));

    triggers.forEach((trigger) => {
      triggerMap.set(trigger, trigger.close);
      trigger.close = () => {
        console.log(`closing menu is disabled by keepMenusOpen feature-flag`);
      };
    });
  }

  private restoreOriginalCloseFunctions() {
    Array.from(triggerMap).forEach(([trigger, originalCloseFunction]) => {
      trigger.close = originalCloseFunction;
      triggerMap.delete(trigger);
    });
  }
}
